import {useEffect, useState} from 'react';

import PubSwitcher from 'components/PubSwitcher/PubSwitcher';
import {useGlobalState} from 'hooks/useGlobalState';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import LayoutPage from 'layouts/LayoutPage/LayoutPage';
import {setNavigationTitleAC} from 'store/app/appSlice';
import {isAdmin, isManager} from 'utils/helpers/getUserRoles';

import AdminPage from './AdminPage/AdminPage';
import ManagerPage from './ManagerPage/ManagerPage';
import NavbarContent from './NavbarContent/NavbarContent';

import './Dashboard.scss';

const Dashboard = () => {
  const dispatch = useSetGlobalState();
  const {user} = useGlobalState((state) => state.app);
  const [showPubSwitcher, setShowPubSwitcher] = useState(false);

  useEffect(() => {
    dispatch(setNavigationTitleAC('dashboard'));
    // eslint-disable-next-line
  }, []);

  return (
    <LayoutPage
      className={`${showPubSwitcher ? 'layout-page--disable-toggler' : ''}`}
      navbarChildren={<NavbarContent setShowPubSwitcher={setShowPubSwitcher} />}
    >
      <div className="dashboard-page">
        {showPubSwitcher && (
          <PubSwitcher onClose={() => setShowPubSwitcher(false)} pubs={user?.attributes.pubs || []} />
        )}
        {isManager(user!) && <ManagerPage />}
        {isAdmin(user!) && <AdminPage />}
      </div>
    </LayoutPage>
  );
};

export default Dashboard;
